import React, { useState } from 'react'

import ksFetch from '@shared/ksFetch';
import TikTokPreview from '@components/Shared/TikTok/Preview'
import { useStreamerKlipCues } from '@shared/hooks/useStreamerKlipCues'

const StreamerKlipCues = ({ streamer_klip_cues, action_cable_url, privileged }) => {
    const [subscribed, setSubscribed] = useState(false)
    const { streamerKlipCues } = useStreamerKlipCues(action_cable_url, streamer_klip_cues, setSubscribed)

    const [showClearCueConfirmation, setShowClearCueConfirmation] = useState(false)

    const restOfCue = streamerKlipCues.slice(1)
    const currentSkc = streamerKlipCues[0] || null

    const skipKlip = async (id) => {
        await ksFetch(`/klips/queue/${id}`, {
            method: 'DELETE',
        })
    }

    const pauseKlip = async (id) => {
        await ksFetch(`/klips/queue/${id}`, {
            method: 'PUT',
            body: JSON.stringify({
                status: 'pause',
            }),
        })
    }

    const playKlip = async (id) => {
        await ksFetch(`/klips/queue/${id}`, {
            method: 'PUT',
            body: JSON.stringify({
                status: 'play',
            }),
        })
    }

    const clearCue = async () => {
        await ksFetch(`/klips/queue/clear`, {
            method: 'DELETE',
        })
        setShowClearCueConfirmation(false)
    }

    const renderTitle = (skc = currentSkc) => {
        if (skc?.streamer_klip?.title?.length > 50) {
            return `${skc?.streamer_klip?.title?.substring(0, 50)}...`;
        }
        return skc?.streamer_klip?.title;
    }

    const renderTriggeredBy = (skc = currentSkc) => {
        if (currentSkc?.triggered_by?.display_name?.length > 50) {
            return `${skc?.triggered_by?.display_name?.substring(0, 50)}...`;
        }
        return skc?.triggered_by?.display_name;
    }

    return (
        <div className="flex flex-col md:flex-row gap-4 max-h-[260px]" data-anycable-subscribed={subscribed}>
            <div className="card-wrapper flex-2 flex-col gap-4">
                <div className="flex items-center justify-between">
                    <h1 className="text-xl font-semibold text-gray-200">
                        Currently Playing
                    </h1>
                    {(currentSkc && privileged) && (
                        <div className="flex gap-2">
                            {currentSkc?.status === 'play' && (
                                <button
                                    id="pause-current-klip"
                                    type="button"
                                    className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs text-blue-400 hover:text-blue-300 hover:bg-blue-900/20 transition-colors cursor-pointer"
                                    onClick={() => pauseKlip(currentSkc?.id)}
                                >
                                    <i data-feather="pause" className="w-4 h-4"></i>
                                    <span>Pause</span>
                                </button>
                            )}
                            {currentSkc?.status === 'pause' && (
                                <button
                                    type="button"
                                    id="play-current-klip"
                                    className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs text-blue-400 hover:text-blue-300 hover:bg-blue-900/20 transition-colors cursor-pointer"
                                    onClick={() => playKlip(currentSkc?.id)}
                                >
                                    <i data-feather="play" className="w-4 h-4"></i>
                                    <span>Play</span>
                                </button>
                            )}

                            <button
                                id="skip-current-klip"
                                type="button"
                                className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs text-yellow-400 hover:text-yellow-300 hover:bg-yellow-900/20 transition-colors cursor-pointer"
                                onClick={() => skipKlip(currentSkc?.id)}
                            >
                                <i data-feather="skip-forward" className="w-4 h-4"></i>
                                <span>Skip</span>
                            </button>
                        </div>
                    )}
                </div>
                {currentSkc ? (
                    <div className="flex flex-col gap-2">
                        <div className="h-[150px]">
                            <TikTokPreview
                                id={currentSkc?.streamer_klip?.klip?.platform_id}
                                sourceUrl={currentSkc?.streamer_klip?.klip?.metadata?.source_url}
                            />
                        </div>
                        <div id="current-playing-klip-info"className="flex justify-between items-center">
                            <h2 className="text-lg text-gray-200">{renderTitle()}</h2>
                            <span className="mt-0.5 text-[11px] text-gray-400 truncate">Triggered by: {renderTriggeredBy()}</span>
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col gap-2">
                        <div className="text-gray-400">No Klip is currently playing</div>
                    </div>
                )}
            </div>
            <div className="card-wrapper flex-1 flex-col gap-4">
                <div className="flex items-center justify-between">
                    <h1 className="text-xl font-semibold text-gray-200">Queue ({restOfCue.length})</h1>
                    {(restOfCue.length > 0 && privileged) &&
                        <>
                            {!showClearCueConfirmation && (
                                <button className="text-xs text-gray-400 hover:text-red-400 transition-colors cursor-pointer flex flex-col items-center gap-1" onClick={() => setShowClearCueConfirmation(true)}>
                                    <i data-feather="trash" className="w-4 h-4"></i>
                                    <span>Clear Queue</span>
                                </button>
                            )}
                            {showClearCueConfirmation && (
                                <div className="flex gap-2">
                                    <button className="text-xs text-gray-400 hover:text-red-400 transition-colors cursor-pointer flex flex-col items-center gap-1" onClick={() => clearCue()}>
                                        <i data-feather="trash" className="w-4 h-4"></i>
                                        <span>Confirm</span>
                                    </button>
                                    <button className="text-xs text-gray-400 hover:text-red-400 transition-colors cursor-pointer flex flex-col items-center gap-1" onClick={() => setShowClearCueConfirmation(false)}>
                                        <i data-feather="x" className="w-4 h-4"></i>
                                        <span>Cancel</span>
                                    </button>
                                </div>
                            )}

                        </>
                    }
                </div>
                {restOfCue.length > 0 ? (
                    <div id="rest-of-cue" className="flex flex-col gap-2 max-h-80 overflow-y-auto pr-1">
                        {restOfCue.map((kc) => {
                            return (
                                <div key={kc.id} className="flex items-center justify-between gap-3 px-3 py-2 rounded-md border border-[#2a2a3e] bg-[#0f0f23]" data-klip-cue-id={kc.id}>
                                    <div className="flex items-center gap-3 min-w-0">
                                        <div className="flex items-center justify-center w-6">
                                            <i data-feather="clock" className="w-4 h-4 text-yellow-400"></i>
                                        </div>
                                        <div className="flex flex-col min-w-0">
                                            <span className="text-sm text-gray-200 truncate">{renderTitle(kc)}</span>
                                            <span className="mt-0.5 text-[11px] text-gray-400 truncate">Triggered by: {renderTriggeredBy(kc)}</span>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        {(privileged && kc.status !== 'skipped') && (
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs text-gray-300 hover:text-white hover:bg-[#1a1a2e] transition-colors cursor-pointer"
                                                onClick={() => skipKlip(kc.id)}
                                                title="Skip"
                                            >
                                                <i data-feather="skip-forward" className="w-4 h-4"></i>
                                                <span>Skip</span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                ) : (
                    <div className="flex flex-col gap-2">
                        <div className="text-gray-400">No klips in queue</div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default StreamerKlipCues
